import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { errorManagerActions } from "@/business/shared/commons/rest/errorManagerActions";
import { ContactMessageRequest } from "@/business/contact/domain/contactRequest";
import { createContactUrl } from "@/business/contact/infrastructure/constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";

export const createContactService = {
    async execute(request: ContactMessageRequest): Promise<void> {
        const url = getEnvVariable
            .execute("VUE_APP_ADMINISTRATION_URL")
            .concat(createContactUrl);
        const response: RestResponse = await restClient().sendRequest(
            url,
            "POST",
            JSON.stringify(request)
        );

        if (!response.isSuccess)
            throw errorManagerActions().transformAV(response.content);
    },
};
